/* global window: true */
import React from 'react';
import _ from 'lodash';
import ReactDOM from 'react-dom';

import './Slide.scss';
import axios from '../../lib/AxiosInstance';
import reducerStore from '../../reducers/reducerStore';
import Widget from '../Widgets/Widget';
import HeaderWidget from '../Widgets/HeaderWidget';
import colorHelper from '../../lib/colorLuminance';

const WidthProvider = require('react-grid-layout').WidthProvider;
let ReactGridLayout = require('react-grid-layout');

ReactGridLayout = WidthProvider(ReactGridLayout);

// TODO: Add more minumum and maximum sizes for the rest of the widgets
//       these numbers must be increase to represent the new 24 grid.
const widgetSizes = {
    ColumnChartWidget: {
        minH: 3,
        minW: 5,
    },
    ColumnChartWidgetGroup: {
        minH: 3,
        minW: 5,
    },
    ColumnTableWidget: {
        minH: 3,
        minW: 3,
    },
    NumberWidget: {
        minH: 3,
        minW: 3,
    },
    NumberWidgetBar: {
        minH: 3,
        minW: 3,
    },
    NumberWidgetCircular: {
        minH: 3,
        minW: 3,
    },
    NumberWidgetHalfCircular: {
        minH: 3,
        minW: 3,
    },
    CustomHTMLWidget: {
        minH: 3,
        minW: 3,
    },
    PieChart: {
        minH: 5,
        minW: 5,
    },
    LineChart: {
        minH: 5,
        minW: 5,
    },
};

class Slide extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            containerWidth: 0,
            rowHeight: 2   
        };      

        // Debounce to avoid performance issues
        this.resize = _.bind(_.debounce(this.resize, 150), this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        if (this.props.isThumbnail) return;

        this.render();

        const rowHeight = this.props.isThumbnail ? 2 : ((this.props.parent.offsetHeight - 10) / 24) - 10;
        const containerWidth = this.props.parent.offsetWidth;
            
            
        this.setState({
            containerWidth,
            rowHeight
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    onLayoutChange(layout) {
        if (this.props.isThumbnail) return;
        const { slide, isEditingWidget } = this.props;

        if (layout && slide) {
            for (let i = 0; i < layout.length; i++) {
                const update = layout[i];
                const widget = _.find(slide.widgets, w => w._id === layout[i].i);

                if (update.i !== 'header') {
                    if (widget.x !== update.x || widget.y !== update.y || widget.height !== update.h || widget.width !== update.w) {
                        widget.x = Math.max(0, update.x);
                        widget.y = Math.max(0, update.y);
                        widget.height = update.h;
                        widget.width = update.w;

                        // Don't want to update PUTs while the widgets are being changed.
                        if (!isEditingWidget) {
                            axios.put(`/api/salestv/${slide.id}/${update.i}`, widget)
                            .then(() => console.log('Updated widget by layout change:', update.i))
                            .catch(error => console.log(error));
                        }

                        this.resize();
                    }
                }
            }
        } else {
            console.log('no layout is available', layout);
        }
    }

    resize() {
        if (!this.props.active) return;

        const node = ReactDOM.findDOMNode(this);
        const rowHeight = this.props.isThumbnail ? 2 : ((node.parentNode.offsetHeight - 10) / 24) - 10;
        const containerWidth = node.parentNode.offsetWidth;
            
        this.setState({
            containerWidth,
            rowHeight
        });
    }

    render() {
        const { slide, slidesData, startEditing, active, isPlaying, isThumbnail, companyProfile, currency } = this.props;
        const { rowHeight, containerWidth } = this.state;
        const colorprofile = {};

        if (!active) return null;

        if (companyProfile) {
            const lighterColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
            colorprofile.background = lighterColor;
        }

        const widgets = slide.widgets.map((widget) => {
            const widgetData = slidesData[widget._id] || [];
            return (
                <div className="box" style={colorprofile} key={widget._id}>
                    <Widget
                        rowHeight={rowHeight}
                        widget={widget}
                        widgetData={widgetData}
                        currency={currency}
                        key={widget._id}
                        isPlaying={isPlaying}
                        startEditing={startEditing}
                        slideId={slide._id}
                        companyProfile={companyProfile}
                        isThumbnail={isThumbnail}
                        slide={slide}
                    />
                </div>
                );
        });

        // TODO: Try to solve the issue when the widget displayTypes are undefined. Exit the render earlier?
        const layout = slide.widgets.map(widget => ({
            i: widget._id,
            x: widget.x,
            y: widget.y,
            w: _.max([_.get(widgetSizes, [widget.displayType, 'minW']), widget.width]),
            h: _.max([_.get(widgetSizes, [widget.displayType, 'minH']), widget.height]),
            minW: _.get(widgetSizes, [widget.displayType, 'minW'], 4),
            minH: _.get(widgetSizes, [widget.displayType, 'minH'], 0),
            static: isThumbnail || isPlaying,
        }));

        if (!isThumbnail) {
            layout.unshift({
                i: 'header',
                x: 0,
                y: 0,
                w: 24,
                h: 3,
                static: true,
            });

            let headerLogoImage = '';
            if (slide.showCompanyLogo && slide.custom && slide.custom.logo) {
                headerLogoImage = slide.custom.logo;
            } else if (slide.showCompanyLogo) {
                headerLogoImage = companyProfile.logo;
            }

            widgets.unshift(
                <div key="header">
                    <HeaderWidget
                        headerType={'text'}
                        headerValue={slide.title}
                        showCompanyLogo={slide.showCompanyLogo}
                        headerLogoImage={headerLogoImage}
                    />
                </div>,
            );
        } else {
            // Move widgets up to take place of unused header
            _.each(layout, (l) => {
                const x = this.props.isChannelThumbnail ? 1.5 : 2;
                // const min = Math.min(l.w, l.h);
                l.h = l.h / x;
                l.y = (l.y / x) - 1;
                // l.w = Math.ceil(l.w / min);
                l.minH = l.h;
                // l.minW = l.w;
                //l.y = l.y - 2;
            });
        }

        // TODO: Use the classnames module instead
        const className = active ? 'layout' : 'layout hide';
        const wrapperClassNames = active ? 'show' : 'show hide';
        const slideOverlayStyle = {};
        const slideStyle = {};
        const color = slide.custom && slide.custom.bgColor ? slide.custom.bgColor : companyProfile.colors.mainBg;

        if (_.get(slide, 'backgroundImage')) {
            const opacity = slide.custom && slide.custom.bgOpacity ? (slide.custom.bgOpacity / 100) : '0.9';
            const bg1 = colorHelper.colorLuminance(color, -0.4);
            const bg2 = colorHelper.colorLuminance(color, -0.6);
            
            slideStyle.position = 'absolute';
            slideStyle.top = '0';
            slideStyle.left = '0';
            slideStyle.width = '100%';
            slideStyle.height = '100%';
            slideStyle.zIndex = '0';
            slideStyle.background = `linear-gradient(
                135deg,
                ${colorHelper.convertHex(bg1, 90)},
                ${colorHelper.convertHex(bg2, 99)}
            )`;

            if (slide.backgroundImage.length > 0) {

                slideOverlayStyle.position = 'absolute';
                slideOverlayStyle.top = '0';
                slideOverlayStyle.left = '0';
                slideOverlayStyle.width = '100%';
                slideOverlayStyle.height = '100%';
                slideOverlayStyle.backgroundImage = `url('${slide.backgroundImage}')`;
                slideOverlayStyle.backgroundSize = 'cover';
                slideOverlayStyle.backgroundRepeat = 'no-repeat';
                slideOverlayStyle.backgroundPosition = 'center center';
                slideOverlayStyle.opacity = opacity; 
                slideOverlayStyle.zIndex = '0';
            }
        }else{
            slideStyle.backgroundColor = color;
        }

        return (
            <div ref={node => this.node = node} className={wrapperClassNames} style={slideStyle}>
                <div className="overlayHolder" style={slideOverlayStyle} />
                <ReactGridLayout
                    className={className}
                    layout={layout}
                    ref={slide._id}
                    cols={24}
                    rowHeight={rowHeight}
                    width={containerWidth}
                    onLayoutChange={(newLayout) => { this.onLayoutChange(newLayout); }}
                    maxRows={24}
                >
                    {widgets}
                </ReactGridLayout>
            </div>
        );
    }
}

Slide.propTypes = {
    active: React.PropTypes.bool,
    companyProfile: React.PropTypes.object,
    currency: React.PropTypes.string,
    isEditingWidget: React.PropTypes.bool,
    isPlaying: React.PropTypes.bool,
    slide: React.PropTypes.object,
    slideId: React.PropTypes.string,
    slidesData: React.PropTypes.object,
    startEditing: React.PropTypes.func,
};

export default Slide;



/** WEBPACK FOOTER **
 ** ./client/components/Slide/Slide.jsx
 **/